<template>
    <div id="personal">
        <Headers :headersText='headersText'></Headers>
        <!-- 名片 -->
        <div class="visitingCard">
            <div class="card">
                <div class="cardLeft">
                    <img :src="userInfo.avatar?userInfo.avatar:'../assets/images/photo.png'" alt="" id="photo">
                    <div class="user">
                        <div class="name">{{userInfo.name}}</div>
                        <div class="ids">ID：{{userInfo.tuser_id}}</div>
                    </div>
                </div>
                <img src="../assets/images/img_43.png" alt="" id="erweima" @click="inErweimaShare">
            </div>
        </div>
    
        <!-- 账号绑定 -->
        <div class="accountNumBind">
            <div class="title">账号绑定</div>
            <div class="other">
                <div class="otherLeft">
                    <img src="../assets/images/img_46.png" alt="">
                    <span>已绑定手机</span>
                </div>
                <div class="otherRight">{{userInfo.phone}}</div>
            </div>
            <div class="other">
                <div class="otherLeft">
                    <img src="../assets/images/img_46.png" alt="">
                    <span>绑定设备</span>
                </div>
                <!--  -->
                <div v-if="userInfo.is_bindudid === 1" class="otherRight">已绑定</div>
                <div v-else @click="bindDevice" class="otherRight extra-style">未绑定<img src="../assets/images/right.png" alt="" class="inRights"></div>
                
            </div>
            <div class="line"></div>
        </div>
        <div class="otherServices">
            <div class="title">其他服务</div>
            <div class="other" @click="inCustomerService">
                <div class="otherLeft">
                    <img src="../assets/images/img_48.png" alt="">
                    <span>我的客服</span>
                </div>
                <img src="../assets/images/right.png" alt="" class="inRights">
            </div>
            <div class="other" @click="inNoviceGuide">
                <div class="otherLeft">
                    <img src="../assets/images/img_47.png" alt="">
                    <span>新手指南</span>
                </div>
                <img src="../assets/images/right.png" alt="" class="inRights">
            </div>
            
            <div class="other" @click="inAboutQDS">
                <div class="otherLeft">
                    <img src="../assets/images/img_45.png" alt="">
                    <span>关于钱大师</span>
                </div>
                <img src="../assets/images/right.png" alt="" class="inRights">
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import Headers from '../components/headersL.vue'
    export default {
        computed: {
            // ...mapState(['isRefresh'])
        },
        components:{
            Headers,
        },
        data() {
            return {
                headersText:'个人中心',

                userInfo:{},
                mobileconfigLink: '' // 验证设备安装文件链接
            }
        },
        created() {
            this.init();
        },
        methods: {
            // ...mapActions(['changeRefreshA']),
            // 初始化 接口调用
            init(){
                this.$loading(true);
                let datas = {}
                this.$http.POSTS('User/userCenter',datas,(res)=>{
                    console.log(res)
                    this.userInfo = res.data;
                    this.$loading(false);
                });
                // 获取安装地址
                this.$http.GETS('System/systemConfig',datas,(res)=>{
                    this.mobileconfigLink = res.data.mobileconfig;
                }); 
            },
            // 进入 新手指南
            inNoviceGuide:function(){
                this.$router.push('/personal/noviceGuide');
            },
            // 进入 关于钱大师
            inAboutQDS:function(){
                this.$router.push('/personal/aboutQDS');
            },
            // 进入 我的客服
            inCustomerService:function(){
                this.$router.push('/personal/customerService');
            },
            // 进入 您的分享二维码
            inErweimaShare:function(){
                this.$router.push('/incomeDetails/erweimaShare');
            },
            // 绑定设备
            bindDevice() {
                location.href = this.mobileconfigLink;
            }
        },
        beforeRouteEnter(to, from, next) {
            if(from.name=='index'){
                to.meta.keepAlive = false;
            } else {
                to.meta.keepAlive = true;
            }
            next();
        },
    }
</script>

<style lang="less" scoped>
    #personal{
        width: 100%;
        height: 100%;
        background: #FFFFFF;
        overflow: scroll;
        // 名片
        .visitingCard{
            width: 375px;
            height: 88px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            .card{
                width: 300px;
                height: 100px;
                background: #FFFFFF;
                border-radius: 5px;
                // border: 1px solid #DEDEDE;
                border:1px solid rgba(222,222,222,.5);
                box-shadow: 0 5px 10px rgba(0, 0, 0, .05);
                margin: 0 auto;
                position: relative;
                top: 8px;
                padding: 0 26px 0 19px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .cardLeft{
                    display: flex;
                    align-items: center;
                    #photo{
                        width: 52px;
                        height: 52px;
                        border-radius: 50%;
                    }
                    .user{
                        color: #151515;
                        margin-left: 14px;
                        font-weight: bold;
                        .name{
                            font-size: 17px;
                            margin-bottom: 10px;
                        }
                        .ids{
                            font-size: 13px;
                        }
                    }
                }
                #erweima{
                    width: 19px;
                    height: 19px;
                }
            }
        }
        // 账号绑定
        .accountNumBind,.otherServices{
            margin-top: 25px;
            padding: 0 15px;
            .title{
                color: #151515;
                font-size: 19px;
                font-weight: bold;
                margin-bottom: 12px;
            }
            .other{
                font-size: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 14px 0;
                .otherLeft{
                    display: flex;
                    align-items: center;
                    img{
                        width: 20px;
                        height: 20px;
                    }
                    span{
                        color: #151515;
                        margin-left: 10px;
                    }
                }
                .otherRight{
                    color: #999999;
                }
                .otherRight.extra-style{
                    color: #5192F5;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .inRights{
                    width: 18px;
                    height: 18px;
                }
            }
            .line{
                height: 1px;
                background: rgba(229, 229, 229, .5);
                margin-top: 16px;
            }
        }
        .accountNumBind{
            margin-top: 45px;
        }
    }
</style>